<main>
    <div class="container">
        <div class="row mb-3">
            <div class="col general-title blue">
                <h2>Simular Seguro</h2>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label>Qual é sua idade ?</label>
                    <input type="number" class="form-control" min="14" max="65" maxlength="2" placeholder="anos" name="idade" autofocus [(ngModel)]="idade" (input)="carregarFatores()">
               </div>
                <small class="form-text text-muted">Idade mínima 14 anos, idade máxima 65 anos.</small>
            </div>
        </div>        

        <div class="row">
            <div class="col-12">
                
                <app-comp-simulador-seguro #compSimuladorSeguro></app-comp-simulador-seguro>  
                
                <div class="clearfix">
                    <button class="btn btn-secondary d-inline-block mt-3 float-right" style="width: 300px;" routerLink="/logado/seguro-adesao" [disabled]="idade==null">Fazer Adesão Agora</button>
                </div>
                
                
            </div>
        </div>

    </div>
</main>